import { environment } from 'environments/environment';

// O Authorization Server publica o issuer sem barra final; um "/" sobrando no CI quebraria as URLs abaixo.
const issuer = environment.SSO_URL.replace(/\/+$/, '');

// O RM roda na raiz em producao e sob /rm/ na dev: o callback segue o base href do index.html.
const baseHref = (document.querySelector('base') && document.querySelector('base').getAttribute('href')) || '/';

export const ssoConfig = {
  issuer: issuer,
  clientId: 'pcdoc-records-manager',
  scope: 'openid profile email pcdoc:records-manager',
  baseHref: baseHref,
  redirectUri: window.location.origin + baseHref.replace(/\/?$/, '/') + 'callback',
  authorizeUrl: issuer + '/oauth2/authorize',
  tokenUrl: issuer + '/oauth2/token',
  endSessionUrl: issuer + '/connect/logout',
  alfrescoTicketUrl: issuer + '/api/v1/auth/alfresco-ticket',
  portalAppsUrl: issuer + '/api/v1/portal/apps',
  // O "Sair" termina na tela de login do SSO, que mostra a mensagem de saida ou de sessao expirada.
  logoutRedirectUri: issuer + '/login?logout=true',
  expiredRedirectUri: issuer + '/login?expired=true'
};



// WEBPACK FOOTER //
// /app/src/app/sso/sso.config.ts